import { useState } from "react"

const data = [
    {
      title: 'AOA',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/1._AOA.pdf',
    },
    {
      title: 'MOA',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/1._MOA.pdf',
    },
    {
      title: 'COI-At the time of Incorporation',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/2._COI.pdf',
    },
    {
      title: 'COI Post Conversion',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/3._COI_Post_Conversion.pdf',
    },
    {
      title: 'BR for IPO',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/4._BR_for_IPO.pdf',
    },
    {
      title: 'SR for IPO',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/5._SR_for_IPO.pdf',
    },
    {
      title: 'BR for Authorization of IPO',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/6._BR_for_Authorisation_of_IPO.pdf',
    },
    {
      title: 'Restated Financial Statement',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/7._Restated_Financial_Statement.pdf',
    },
    {
      title: 'Certificate on Possible Tax Benefit',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/8._Certificate_on_Possible_Tax_benefit.pdf',
    },
    {
      title: 'SDDR PCS Certificate',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'Certificate for KPI',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/13._Certificate_for_KPI.pdf',
    },
    {
      title: 'Restated SHA_7Aug24',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'Addendum to SHA_8June25',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'Debenture Trustee Agreement',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/15._Debenture_Trustee_Agreement.pdf',
    },
    {
      title: 'Debenture Turst Deed',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/16._Debenture_Trust_Deed.pdf',
    },
    {
      title: 'Smart Village and BR 29th June 2023',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'SVM BR Amendment Agreement 10th June 2024',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'BR and IFFCO Kisan Service Agreement',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'Consent of BRLM',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/6._Consent_of_BRLM.pdf',
    },
    {
      title: 'Consent of Underwriter',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/7._Consent_of_Underwriter.pdf',
    },
    {
      title: 'Consent Letter PCS Preeti Jain',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/11._Consent_Letter_PCS-Preeti_jain.pdf',
    },
    {
      title: 'Consent of Banker to Company HDFC',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/12._Banker_to_Company-HDFC.pdf',
    },
    {
      title: 'MSA Aryatech and BR 09th June 2025',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'Behtar Zindagi and BR 23rd March 2023',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'Consent Banker to Company IDFC',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/12._Consent_banker_to_company-IDFC.pdf',
    },
    {
      title: 'Consent Letter of Peer Review Auditor',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/14._Consent_Letter_of_Peer_Review_Auditor.pdf',
    },
    {
      title: 'Obopay BR Business Agreement',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'Consent of Legal Advisor',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/16._Consent_Legal_Advisor.pdf',
    },
    {
      title: 'Consent of RTA',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/18._Consent_of_RTA.pdf',
    },
    {
      title: 'Consent and NOC for IPO-RevX',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/20._n_22._Consent_of_RevX_and_NOC.pdf',
    },
    {
      title: 'Deffered Consideration Greoigids',
      // month : months[0],
      fileUrl: '',
    },
    {
      title: 'Consent of Debenture Trustee',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/consents/21._Consent_of_Debenture_Trustee_Axis_Trustee_Final.pdf',
    },
    {
      title: 'BR for Approval DRHP',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/23._BR_for_Approval_of_DRHP.pdf',
    },
    {
      title: 'BR for Approval RHP',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/23._BR_for_Approval_of_RHP.pdf',
    },
    {
      title: 'Site Visit CO',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/24._Site_Visit_CO.pdf',
    },
    {
      title: 'Site Visit RO',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/24._Site_Visit_RO.pdf',
    },
    {
      title: 'DD Certificate and Checklist',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/25._DD_Certificate_and_Checklist.pdf',
    },
    {
      title: 'IP Approval Letter',
      // month : months[0],
      fileUrl: 'https://assets.bharatrohan.in/material_document/26._IP_Approval_Letter.pdf',
    }
]

export default function Document01() {
    const [selected, setSelected] = useState<number>(0)
    const isMobile = window.innerWidth<1024;
    
    return (
        <div className="py-8 lg:pb-10"> {/* Replaceable line is down */}
      {/* <div className="py-8 bg-cream lg:pb-10"></div> */}
      {/* <div className="w-container-lg"> */}
        <div className="flex flex-col lg:flex-row items-start gap-x-12 xl:gap-x-16 2xl:gap-x-20 gap-y-6 md:gap-y-12">
          <div className="grid  w-full blade-top-padding-sm lg:pt-0 lg:w-[100%] gap-y-4 lg:gap-y-6 flex-col">
            {data.map((item, index) => (
              <div className='flex justify-around sm:flex'>
                <div className="md:w-[70%] sm:w-2" key={index}>
                  <div
                    onClick={() => {
                      setSelected(index)
                    }}
                    className={`flex w-full py-4 border px-4 sm:px-6 md:px-8 lg:px-4 xl:px-6 border-green items-center justify-between cursor-pointer transition-al duration-1000 ${
                      selected === index
                        ? 'bg-transparent cursor-auto pt-6'
                        : 'bg-transparent'
                    }`}
                  >
                    {item.fileUrl ? (
                      <a
                        href={item.fileUrl}
                        target="_blank"
                        className="grid w-full grid-cols-[2.5rem_1fr_auto] sm:grid-cols-[3rem_1fr_auto] xl:grid-cols-[4rem_1fr_auto]"
                      >
                        <span
                          className={`text-lg lg:text-xl 2xl:text-xl opacity-25 font-bold transition-all duration-1000 ${
                            selected === index ? 'text-black' : 'text-black'
                          }`}
                        >
                          {index >= 9 ? `${index + 1}` : `0${index + 1}`}
                        </span>
                        <h4
                          className={`${
                            selected === index ? 'text-green' : 'text-green'
                          } font-semibold text-left transition-all duration-1000 self-center 2xl:text-xl overflow-hidden`}
                        >
                          <div
                            className={`inline-block whitespace-nowrap ${
                              isMobile && item.title.length > 25
                                ? 'animate-slide 2xl:animate-none px-2'
                                : item.title.length > 40
                                ? 'animate-slide'
                                : 'w-80'
                            }`}
                          >
                            {item.title}
                          </div>
                        </h4>
                      </a>
                    ) : (
                      <div className="grid w-full grid-cols-[2.5rem_1fr_auto] sm:grid-cols-[3rem_1fr_auto] xl:grid-cols-[4rem_1fr_auto]">
                        <span
                          className={`text-lg lg:text-xl 2xl:text-xl opacity-25 font-bold transition-all duration-1000 ${
                            selected === index ? 'text-black' : 'text-black'
                          }`}
                        >
                          {index >= 9 ? `${index + 1}` : `0${index + 1}`}
                        </span>
                        <h4
                          className={`${
                            selected === index ? 'text-green' : 'text-green'
                          } font-semibold text-left transition-all duration-1000 self-center 2xl:text-xl overflow-hidden`}
                        >
                          <div
                            className={`inline-block whitespace-nowrap ${
                              isMobile && item.title.length > 25
                                ? 'animate-slide 2xl:animate-none px-2'
                                : item.title.length > 40
                                ? 'animate-slide'
                                : 'w-80'
                            }`}
                          >
                            {item.title}
                          </div>
                        </h4>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      {/* </div> */}
    </div>
    )
} 